import { Checkpoint, ICheckpoint } from "./checkpoint";

export interface ITravelRoute {
  id?:number,
  name?: string,   
  companyId?: number,
  distance?: number,
  timeHours?: number,
  description?: string,
  checkpoints?: ICheckpoint[],
  numberCheckPoint?: number,
  endName?: string,
  originName?: string,
  activateReverse?: number
}

export class TravelRoute implements ITravelRoute {
  id?: number;
  name?: string;
  companyId?: number;
  distance?: number;
  timeHours?: number;
  description?: string;
  checkpoints?: ICheckpoint[];
  numberCheckPoint?: number;
  endName?: string;
  originName?: string;
  activateReverse?: number
}
